export default __webpack_public_path__ + "static/media/close.3c6fba62.svg";